<template>
  <ul class="npa-document-list">
    <li v-for="document in documents" :key="document.id">
      <template>
        <div class="version-body">
          <template v-if="['pdf', 'png', 'jpeg', 'jpg'].includes(document.fileExtension)">
            <a
              class="file-link"
              :href="baseUrl + document.fullFilesDirectory"
              target="_blank"
            >
              <span v-if="document.fileExtension === 'pdf'">
                <i
                  v-if="document.fileExtension"
                  :class="'pro-icon-' + document.fileExtension"
                  aria-hidden="true"
                ></i>
              </span>
              <span v-else>
                <i
                  v-if="document.fileExtension"
                  class="pro-icon-file"
                  aria-hidden="true"
                ></i>
              </span>
              {{  document.description  }}
            </a>
          </template>
          <template v-else>
            <a
              href="#"
              class="file-link"
              :aria-label="$t('Открыть документ') + ': ' + document.description"
              @click.prevent="previewDocumentDialog(document.id, true)"
            >
              <i
                v-if="document.fileExtension"
                :class="'pro-icon-' + document.fileExtension"
                aria-hidden="true"
              ></i>
              {{  document.description  }}
            </a>
            <v-dialog
              v-model="previewDocsModal[document.id]"
              max-width="1200"
            >
              <v-card class="modal">
                <div class="modal-head">
                  <v-btn
                    color="modal-close"
                    :aria-label="$t('Закрыть')"
                    @click="
                      previewDocumentDialog(document.id, false)
                    "
                  >
                    <span class="pro-icon-close1" aria-hidden="true"></span>
                  </v-btn>
                </div>
                <div class="modal-body">
                  <OfficePreviewBridge
                    :file-url="baseUrl + document.fullFilesDirectory"
                  />
                </div>
              </v-card>
            </v-dialog>
          </template>
        </div>
      </template>
      <span
        v-if="user && (user.roleAdmin || user.roleOperator)"
        class="remove"
        role="button"
        tabindex="0"
        :aria-label="$t('Удалить документ') + ': ' + document.description"
        @click="remove(document.id)"
        @keyup.enter="remove(document.id)"
        @keyup.space="remove(document.id)"
      >
        <i
          class="fa fa-trash" aria-hidden="true">
        </i>
      </span>
    </li>
  </ul>
</template>

<script>
  import OfficePreviewBridge from '@/components/app/OfficePreviewBridge.vue'

export default {
    name: 'DocumentList',
    components: {
      OfficePreviewBridge
    },

    props: {
      documents: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        previewDocsModal: []
      }
    },

    computed: {
      baseUrl () {
        return process.env.VUE_APP_BACK_URL
      },
      user() {
        return this.$store.state.getNpaData.currentUser
      },
    },

    methods: {
      previewDocumentDialog(id, flag) {
        this.$set(this.previewDocsModal, id, flag)
      },

      remove (documentId) {
        this.$emit('remove', documentId)
      }
    }
  }
</script>
<style>
  .npa-document-list {
    padding-left: 0px !important;
    padding-top: 40px !important;
  }

  .remove {
    margin-left: 10px;
    cursor: pointer;
  }

  li {
    display: flex;
    align-items: center;
  }
</style>
